export default "__VITE_ASSET__DMdhO9rn__"